<template>
  <div class="order-share">
    <div class="text-center" v-if="!order.order_no">
      <Loading></Loading>
    </div>
    <div v-if="order.order_no">
      <div class="text-center order-code">
        任务号：<span>{{order.order_no}}</span>
      </div>
      <div class="text-center order-title">下单人 {{order.single_info.username}} 发布了一个金额为 {{order.currency_symbol}}{{order.total_amount}} 的 {{order.business_name}} 下单任务，请及时支付。</div>
      <div class="order-content">
        <el-row :gutter="60">
          <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="18">
            <div class="product-list-box">
              <ProductTitle :editable="false" :info="order"></ProductTitle>
              <ul>
                <li class="clearfix" v-for="goods in order.goods_list">
                  <div class="img-container">
                    <a :href='goods.website.substr(0,7).toLowerCase() == "http://" || goods.website.substr(0,8).toLowerCase() == "https://" ? goods.website : "http://"+ goods.website' target="_blank">
                    <img v-if="goods.picture" :src="goods.picture"/>
                    <img v-else src="https://pic.joyorders.com/blank.png"/>
                    </a>
                  </div>
                  <div class="des-container">
                    <h4><a :href='goods.website.substr(0,7).toLowerCase() == "http://" || goods.website.substr(0,8).toLowerCase() == "https://" ? goods.website : "http://"+ goods.website' target="_blank">{{goods.name}}</a></h4>
                    <p><span>规格：</span>{{goods.spec}}</p>
                    <p><span>数量：</span>{{goods.number}}</p>
                    <div class="bottom-container">
                      <div class="price-con" v-if="goods.discounted_price != goods.price">
                        <del>{{goods.price|currency(goods.currency_symbol)}}</del>
                        <p>{{(goods.discounted_price || goods.price)|currency(goods.currency_symbol)}}</p>
                      </div>
                      <div v-if="goods.discounted_price == goods.price">
                        <p class="order-price"> {{(goods.price)|currency(order.currency_symbol)}}</p>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="box2">
              <h4>收货地址</h4>
              <p class="transport-company" v-if="order.address.country != '中国大陆(CN)'">{{order.address.first_name}} {{order.address.last_name}}</p>
              <p class="transport-company" v-if="order.address.country == '中国大陆(CN)'">{{order.address.last_name}} {{order.address.first_name}}</p>
              <p class="blod" v-if="order.address.transport_company">{{order.address.transport_company}} {{order.address.store_number}}</p>
              <p class="blod" v-if="order.address.business_or_private == 2"><i class="icon-home"></i>私人地址</p>
              <p>{{order.address.address1}}</p>
              <p>{{order.address.city}}, {{order.address.province}} {{order.address.zip_code}}</p>
              <p>{{order.address.coutry}}</p>
              <p>电话：{{order.address.mobile}}</p>
            </div>
            <div class="box2">
              <h4>下单说明</h4>
              <p>
                部分商品缺货时{{order.check_full_goods ? '仍可下单' : '不能下单'}}
              </p>
              <p>
                备注：{{order.remark}}
              </p>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <div class="order-total">
              <h2>订单总计</h2>
              <el-row>
                <el-col :span="10">商品：</el-col>
                <el-col :span="14" class="text-right">{{totalProductPrice | currency(order.currency_symbol)}}</el-col>
              </el-row>
              <el-row>
                <el-col :span="10">税费：</el-col>
                <el-col :span="14" class="text-right">{{order.tax_amount | currency(order.currency_symbol)}}</el-col>
              </el-row>
              <el-row>
                <el-col :span="10">运费：</el-col>
                <el-col :span="14" class="text-right">{{order.transport_amount | currency(order.currency_symbol)}}</el-col>
              </el-row>
              <el-row>
                <el-col :span="10">商家订单总计：</el-col>
                <el-col :span="14" class="text-right">{{(Number(totalProductPrice) + Number(order.tax_amount) + Number(order.transport_amount)) | currency(order.currency_symbol)}}</el-col>
              </el-row>
              <el-row>
                <el-col :span="10">金额调整：</el-col>
                <el-col :span="14" class="text-right">{{order.other_amount | currency(order.currency_symbol)}}</el-col>
              </el-row>
              <el-row>
                <el-col :span="10">汇率：</el-col>
                <el-col :span="14" class="text-right">{{order.conditions.rate}}</el-col>
              </el-row>
              <el-row>
                <el-col :span="10">优惠码：</el-col>
                <el-col :span="14" class="text-right">{{order.coupon_text}}</el-col>
              </el-row>
              <el-row class="total-amount">
                <el-col :span="10">总计：</el-col>
                <el-col :span="14" class="text-right">{{order.total_amount | currency(order.currency_symbol)}}/{{(order.total_amount * order.conditions.rate)| currency('¥')}}</el-col>
              </el-row>
              <div class="payment-btn">
                <PaymentDialog v-on:success="updatePayment" :paymentId="'2'" style="display:block;">
                  <el-button class="block" type="info">确认支付</el-button>
                </PaymentDialog>
              </div>
            </div>
            <div class="order-total payment-type">
              <h2>支付方式</h2>
              <PayFrom :paymentId="'2'" :newWindow="true" :showForm="false" v-on:success="submit" btnTxt="确认支付"></PayFrom>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog v-if="paymentDialogVisible" class="el-dialog-sm" :close-on-click-modal="false" :visible.sync="paymentDialogVisible" width="90%">
      <PaymentTip v-on:close="closeOtherPaymentDialogVisible" :orderId="order.id" :newWindow="newWindow" :order="order" :type="type" :orderNo="order.order_no"></PaymentTip>
    </el-dialog>
  </div>
</template>

<script>
import ProductTitle from '../../publish_task/cart/ProductTitle'
import api from '../../../services/api.js'
// import { FILE_HOST } from '../../../services/constant.js'
import SingleAddress from '../../publish_task/address/SingleAddress'
import Loading from '../../../components/Loading'
import PayFrom from '../../publish_task/payment/Form'
import PaymentTip from '../../payment/PaymentTip'
import PaymentDialog from '../../publish_task/payment/PaymentDialog'
let $ = require('jQuery')

export default {
  name: 'OrderList',
  created () {
    this.initEditOrder()
    setTimeout(() => {
      $('#app').addClass('use-mobile-style')
    }, 100)
  },
  components: {
    ProductTitle: ProductTitle,
    SingleAddress: SingleAddress,
    Loading: Loading,
    PayFrom: PayFrom,
    PaymentTip: PaymentTip,
    newWindow: null,
    PaymentDialog: PaymentDialog,
    totalProductPrice: 0
  },
  data () {
    return {
      order: {
        address: {}
      },
      paymentDialogVisible: false,
      type: null
    }
  },
  methods: {
    async initEditOrder () {
      let orderId = this.$route.query.id
      let random = this.$route.query.random
      if (orderId) {
        let res = await api.getDetailById(this, {
          id: orderId,
          random: random
        })
        this.order = res.body.result || {}
        console.log(this.order)
        try {
          this.order.conditions = JSON.parse(this.order.conditions)
        } catch (e) {

        }
        if (this.order.coupon) {
          try {
            this.order.coupon = JSON.parse(this.order.coupon)
            this.order.coupon_text = this.order.coupon.join(' ')
          } catch (e) {

          }
        }
        // await this.getGroupBussinessList(this.order)
        this.calTotalProductPrice()
      }
    },
    calTotalProductPrice () {
      this.totalProductPrice = 0
      _.each(this.order.goods_list, goods => {
        let price = goods.discounted_price || goods.price
        price = price * goods.number
        this.totalProductPrice += Number(price)
      })
    },
    async getGroupBussinessList (data) {
      let res = await api.getGroupBussinessList(this, {setLs: true, getLs: true,getLsTime: new Date().getTime()})
      let result = res.body.result
      this.bussinessList = _.groupBy(result, 'id')
      if (this.bussinessList[data.business_id]) {
        data.business_name = this.bussinessList[data.business_id][0].name
        data.business_website = this.bussinessList[data.business_id][0].website
      }
    },
    async submit (data) {
      let offline_payment = 0
      if (data.type == 0) {
        offline_payment = 1
        let res = await api.post(this, {
          path: 'order.php',
          api: 'update_payment_type_by_buyer',
          data: {
            order_id: this.order.id,
            payment_type_id: data.type,
            offline_payment: offline_payment,
            update_time: this.order.update_time
          },
          loading: 'loading'
        })
        res = res.body
        if (res.status == 'ok') {
          this.$router.push({ path: '/customer/task/list'})
          return
        }
      }
      this.newWindow = data.newWindow
      this.type = data.type
      this.paymentDialogVisible = true
    },
    closeOtherPaymentDialogVisible () {
      this.paymentDialogVisible = false
    },
    async updatePayment (data) {
      let offline_payment = 0
      if (data.type == 0) {
        offline_payment = 1
        let res = await api.post(this, {
          path: 'order.php',
          api: 'update_payment_type_by_buyer',
          data: {
            order_id: this.order.id,
            payment_type_id: data.type,
            offline_payment: offline_payment,
            update_time: this.order.update_time
          },
          loading: 'loading'
        })
        res = res.body
        if (res.status == 'ok') {
          this.$router.push({ path: '/customer/task/list'})
          return
        }
      }
      if (data.type == 3) {
        this.newWindow = window
      }
      this.type = data.type
      this.paymentDialogVisible = true
    }
  },
  watch: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.order-share {
  margin-top: -20px;
  padding: 0 15px 60px;

  .order-code {
    &, span {
      font-size: 18px;
    }

    span {
      color: #666;
    }
  }

  .order-content {
    max-width: 1140px;
    margin: 0 auto;

    a {
      color: #333;
    }
  }

  .order-title {
    font-size: 14px;
    margin-top: 10px;
    line-height: 20px;
    margin-bottom: 48px;
  }

  .product-list-box {
    li {
      padding: 30px 0;
      border-top: 1px solid #DEE2EC;

      &:last-child {
        border-bottom: 1px solid #DEE2EC;
      }
    }
  }

  .order-total {
    border-top: 1px solid #DEE2EC;
    border-bottom: 1px solid #DEE2EC;
    padding: 20px 0;

    * {
      font-size: 18px;
      line-height: 25px;
    }

    h2 {
      font-size: 22px;
      line-height: 30px;
      margin-bottom: 10px;
    }
    .total-amount {
      font-weight: bold;
    }
  }

  .payment-type {
    border-top: none;
    border-bottom: none;
  }

  .box2 {
    p {
      font-size: 18px!important;
      line-height: 24px;
    }
  }

  .payment-btn {
    display: none;
  }
}
@media (max-width: 768px) {
  .order-share {
    margin-top: 0;

    .payment-type {
      display: none;
    }

    .payment-btn {
      display: block;
      margin-top: 20px;
    }

    .order-title {
      margin-bottom: 30px;
    }

    .order-total {
      border-top: none;
      border-bottom: none;
    }

    .img-container {
      width: 100px;
      height: 100px;
    }

    .des-container {
      height: 100px;
      padding-right: 120px;
      margin-left: 120px;
    }

    .box2 {
      h4 {
        font-size: 16px!important;
      }
      p {
        font-size: 16px!important;
        line-height: 20px;
      }
    }

    .order-total {
      * {
        font-size: 16px;
        line-height: 20px;
      }

      h2 {
        font-size: 20px;
        line-height: 28px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/orders/share/Order.vue